import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Flex,
  Group,
  Input,
  Menu,
  MultiSelectProps,
  rem,
  Select,
  Text,
  Title,
  Tooltip
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconCaretDown,
  IconEdit,
  IconFileExport,
  IconFileUpload,
  IconReload,
  IconSearch,
  IconSwitch,
  IconTransactionEuro,
  IconX
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateTransfer
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import "../../../Styles/tab.component.css";
import "../../../Styles/compact-table-head.css";
import CreateWarehouseLocationList from "./CreateWarehouseLocationList";
import DeleteWarehouseLocation from "./DeleteWarehouseLocation";
import EditWarehouseLocation from "./EditWarehouseLocation";
import ImportExcelView from "./ImportExcelView";
type Props = {
  isCheckViTri?: boolean;
  /** Ẩn breadcrumb khi component được nhúng trong tab của màn hình khác */
  hideBreadcrumb?: boolean;
  handleCreateLocation?: (ids: string[], idGroup: string) => void;
  idGroup?: string;
  idsDepartment?: string;
}
const WarehouseLocationList = ({ isCheckViTri, hideBreadcrumb, idGroup, handleCreateLocation, idsDepartment }: Props) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventoryPosition[]>([]);
  const [dataWarehouse, setDataWarehouse] = useState<ComboboxItem[]>([]);
  const [dataBranch, setBranch] = useState<Warehouse[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [search, setSearch] = useState({
    keySearch: "",
    branchCode: "",
    branchId: 0,
    invId: 0,
    startDate: "",
    endDate: "",
    active: "",
    position: [],
  });
  type InventoryPosition = {
    id: number;
    invId: number;
    invCode: string;
    subInvId: number;
    subInvCode: string;
    positionCode: string;
    positionName: string;
    /** Mã chi nhánh bên ERP Asia - join từ danh mục chi nhánh */
    invAsiaCode: string | null;
    /** Mã kho bên ERP Asia - join từ danh mục kho */
    subInvAsiaCode: string | null;
    /** Mã vị trí kho bên ERP Asia - cột của chính vị trí kho */
    attribute8: string | null;
    active: boolean | null;
    createDate: string | null;
    createBy: number | null;
    lastUpdateDate: string | null;
    lastUpdateBy: number | null;
  };
  type Warehouse = {
    id: number;
    name: string;
    att1: string | null;
    att2: string | null;
    att3: number;
    att4: number;
    att5: string | null;
    disabled: boolean;
    group: string | null;
    selected: boolean;
    text: string;
    value: string;
  };
  const handleChangeSearchValue = (
    value: string | null | string[],
    key: string
  ) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : 0,
    }));
  };
  console.log(search);
  const loadingLocator = async () => {
    try {
      const response = await repositoryMdm.get<MessageResponse<[]>>(
        `/api/v1/SyncData/sync-position`
      );

      if (response && response.data) {
        NotificationExtension.Success("Cập nhật thành công !");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        NotificationExtension.Fails("Cập nhật thất bại !");
      }
    } catch (error) {
      NotificationExtension.Warn("Đã xảy ra lỗi trong quá trình cập nhật!");
      console.error(error);
    }
  };

  const DataWarehouse = async () => {
    try {
      let url = `api/v1/TblDmInventory/get-select-by-branch`;
      console.log("branchId " + search.branchId);
      if (search.branchId) {
        url += "?branchId=" + search.branchId;
      }
      const response = await repositoryPos.get(url);
      if (response && response.success) {
        const result = response.data
          ?.filter((item: any) => item.inventoryId && item.inventoryName)
          ?.map((item: any) => ({
            label: item.inventoryName?.toString(),
            value: item.inventoryId?.toString(),
          }));
        setDataWarehouse(result);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataBranch = async () => {
    try {
      let url = `api/v1/TblDmInventory/get-select-branch`;
      const response = await repositoryPos.get(url);
      console.log(response);
      if (response && response.success) {
        setBranch(response.data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useEffect(() => {
    DataWarehouse();
  }, [search.branchId]);

  useEffect(() => {
    DataBranch();
  }, []);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "invCode",
        header: "Mã chi nhánh",
        size: 150,
      },
      {
        accessorKey: "invName",
        header: "Tên chi nhánh",
        size: 240,
      },
      {
        accessorKey: "invAsiaCode",
        header: "Mã chi nhánh Asia",
        size: 170,
      },
      {
        accessorKey: "subInvCode",
        header: "Mã kho",
        size: 120,
      },
      {
        accessorKey: "subInvName",
        header: "Tên kho",
        size: 240,
      },
      {
        accessorKey: "subInvAsiaCode",
        header: "Mã kho Asia",
        size: 150,
      },
      {
        accessorKey: "positionCode",
        header: "Mã vị trí Kho",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="violet">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "positionName",
        header: "Tên vị trí kho",
      },
      {
        accessorKey: "attribute8",
        header: "Mã vị trí Asia",
        size: 150,
      },
      // {
      //   accessorKey: "active",
      //   header: "Trạng thái",
      //   Cell: ({ cell }) => (
      //     <div
      //       style={{
      //         backgroundColor: cell.getValue() ? "green" : "red",
      //         color: "white",
      //         borderRadius: "50px",
      //         padding: "5px",
      //         textAlign: "center",
      //         width: "120px",
      //       }}
      //     >
      //       {cell.getValue() ? "Hoạt động" : "Không hoạt động"}
      //     </div>
      //   ),
      // },
      {
        accessorKey: "attribute4",
        header: "Lên bảng kê hàng lỗi",
        size: 160,
        // Mantine Select không chọn được option có value = "" nên dùng "0" + filterFn riêng
        filterFn: (row, _id, filterValue) => {
          if (filterValue === undefined || filterValue === null || filterValue === "")
            return true;
          const isChecked = row.original.attribute4 === 1;
          return String(filterValue) === "1" ? isChecked : !isChecked;
        },
        mantineFilterSelectProps: {
          data: [
            { label: "Có", value: "1" },
            { label: "Không", value: "0" },
          ],
        },
        filterVariant: "select",
        // không căn giữa ô tiêu đề: MRT sẽ thêm padding-left 1.75rem để chừa chỗ
        // cho nút ⋮ (vẫn cộng dù đã tắt enableColumnActions) làm nhãn lệch phải
        mantineTableBodyCellProps: { align: "center" },
        Cell: ({ row }) => (
          <Checkbox
            readOnly
            checked={row.original.attribute4 === 1}
            styles={{ input: { cursor: "default" } }}
          />
        ),
      },

      {
        accessorKey: "active",
        header: "Sử dụng",
        filterFn: "equals",
        mantineFilterSelectProps: {
          data: [
            { label: "Đang sử dụng", value: "true" },
            { label: "Dừng sử dụng", value: "false" },
          ],
        },
        filterVariant: "select",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={row.original.active ? "teal" : "red"}>
              {row.original.active ? "Đang sử dụng" : "Dừng sử dụng"}
            </Badge>
          </>
        ),
      },

      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      // {
      //   accessorKey: "createBy",
      //   header: "Id người Tạo",
      //   size: 30,
      // },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày Cập Nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      // {
      //   accessorKey: "lastUpdateBy",
      //   header: "Id người cập nhật",
      //   size: 30,
      // },

      {
        accessorKey: "id",
        header: "id",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    [data]
  );

  function processTaskActionMenu(row: MRT_Row<any>): any {
    return (
      <>
        <Tooltip label="Sửa">
          <ActionIcon variant="light" aria-label="Settings" color="yellow">
            <IconEdit size={20} onClick={() => handleEdit(row?.original.id)} />
          </ActionIcon>
        </Tooltip>
        {/* <Tooltip label="Xóa">
          <ActionIcon variant="light" aria-label="Settings" color="red">
            <IconTrash
              size={20}
              onClick={() => handleDelete([row?.original.id])}
            />
          </ActionIcon>
        </Tooltip> */}
      </>
    );
  }
  const handleEdit = (id: number | string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa</Title>
        </>
      ),
      centered: true,
      size: 700,
      children: <EditWarehouseLocation id={id} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const handleAdd = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Tạo mới</Title>
        </>
      ),
      centered: true,
      size: 700,
      children: <CreateWarehouseLocationList onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleImportExcel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Import excel danh mục vị trí kho</Title>
        </>
      ),
      size: "auto",
      yOffset: "3%",
      children: <ImportExcelView onSuccess={fetchDataWarehouse} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const handleDelete = (ids: (number | string)[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa bảng vị trí kho</Title>
        </>
      ),
      children: (
        <DeleteWarehouseLocation idItems={ids} onClose={setDeleteViewStatus} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const exportDataExcel = async () => {
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
      }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch?.trim()?.toLowerCase()}`;
    }
    if (search.startDate) {
      url += `&StartTime=${search.startDate}`;
    }
    if (search.endDate) {
      url += `&EndTime=${search.endDate}`;
    }
    if (search.active) {
      url += `&Active=${search.active}`;
    }
    if (search.position && search.position.length > 0) {
      search.position.forEach((position) => {
        url += `&Position=${position}`;
      });
    }
    const baseUrl = `/api/v1/ExportExcel/export-iyem-position${url}`;

    const _url = BASE_API_DELIVERY + baseUrl;
    const token = localStorage.getItem("token");

    const response = await fetch(_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-excel",
        Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const urlss = window.URL.createObjectURL(blob);
    const _name = new Date().toISOString().slice(0, 10);
    let filename = "Danh_muc_vi_tri_kho.xlsx";
    const link = document.createElement("a");
    link.href = urlss;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
  const fetchDataWarehouse = async () => {
    setIsLoading(true);
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
      }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch?.trim()?.toLowerCase()}`;
    }
    if (search.startDate) {
      url += `&StartTime=${search.startDate}`;
    }
    if (search.endDate) {
      url += `&EndTime=${search.endDate}`;
    }
    if (search.active) {
      url += `&Active=${search.active}`;
    }
    if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }
    if (search.invId) {
      url += `&InvId=${search.invId}`;
    }
    if (search.position && search.position.length > 0) {
      search.position.forEach((position) => {
        url += `&Position=${position}`;
      });
    }
    try {
      const response = await repositoryDelivery.get(
        `api/v1/TblDmItemPosition/get-list${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        table.resetRowSelection();
      } else {
        setData([]);
        setRowCount(0);
      }
      setIsError(false);
    } catch (error) {
      setData([]);
      setRowCount(0);
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const DataPosition = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&Position=${keySearch}`;
      }
      const response = await repositoryDelivery.get(
        `api/v1/TblDmItemPosition/get-list-position?Skip=0&Take=25` + url
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.positionCode && i.positionName)
          .map((branch: any) => ({
            value: branch.positionCode,
            label: branch.positionCode + " - " + branch.positionName,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value))
        ).map((value) =>
          transformedData.find((item: any) => item.value === value)
        );
        setDataInvCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  useEffect(() => {
    fetchDataWarehouse();
  }, [deleteViewStatus, pagination]);

  const table = useMantineReactTable({
    columns,
    data,
    enableRowSelection: true,
    enableMultiRowSelection: true,
    enableSelectAll: true,
    enableColumnFilters: true,
    // bỏ icon sắp xếp + nút ⋮ trên tiêu đề cho gọn (lọc đã có ở thanh tìm kiếm phía trên)
    enableSorting: false,
    rowCount,
    enableColumnActions: false,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Input
            style={{ flex: 1, maxWidth: "180px" }}
            placeholder="Nhập tìm kiếm"
            type="text"
            leftSection={<IconSearch size={"20"} color="#15aabf" />}
            onChange={(e) => {
              handleChangeSearchValue(e.target.value ?? "", "keySearch");
            }}
          />
          <Select
            size="sm"
            placeholder="Chi nhánh"
            searchable
            clearable
            data={dataBranch
              .map((item) => ({
                value: item.value.toString(), // Giá trị của option (bắt buộc phải là string)
                label: `[${item.att2}] ${item.text}`, // Nội dung hiển thị
              }))
              .filter((x) => x.value !== "-1")}
            style={{ flex: 1, maxWidth: "180px" }}
            leftSection={<IconSwitch size={20} color="#15aabf" />}
            onChange={(value) =>
              handleChangeSearchValue(value ?? "", "branchId")
            }
          />
          <Select
            size="sm"
            placeholder="Kho"
            searchable
            clearable
            // onDropdownOpen={DataWarehouse}
            data={dataWarehouse}
            style={{ flex: 1, maxWidth: "180px" }}
            leftSection={<IconSwitch size={20} color="#15aabf" />}
            onChange={(value) => handleChangeSearchValue(value ?? "", "invId")}
          />
          {/* <DatePickerInput
            type="range"
            size="sm"
            placeholder="Từ ngày - Đến ngày"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            onChange={(e) => {
              handleChangeSearchValue(
                formatDateNotTimeZone(e[0]) ?? "",
                "startDate"
              );
              handleChangeSearchValue(
                formatDateNotTimeZone(e[1]) ?? "",
                "endDate"
              );
            }}
            leftSection={<IconCalendar color="#15aabf" />}
            w={250}
            clearable
          /> */}
          {/* <MultiSelect
            size="sm"
            placeholder="Mã vị trí kho"
            clearable
            searchable
            data={dataInvCode.map((x) => x.value)}
            value={search.position}
            renderOption={renderMultiSelectOption}
            leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
            onSearchChange={(value) => {
              if (value.length >= 3) {
                DataPosition(value);
              }
            }}
            onChange={(value) => {
              handleChangeSearchValue(value, "position");
            }}
          /> */}
          <Select
            size="sm"
            placeholder="Trạng thái"
            searchable
            clearable
            data={[
              { value: "true", label: "Hoạt động" },
              { value: "false", label: "Không hoạt động" },
            ]}
            style={{ flex: 1, maxWidth: "180px" }}
            leftSection={<IconSwitch size={20} color="#15aabf" />}
            onChange={(value) => handleChangeSearchValue(value ?? "", "active")}
          />
          <Button
            color="blue"
            variant="outline"
            onClick={async () => {
              // luôn về trang 1 khi tìm kiếm, tránh đứng ở trang cũ không còn dữ liệu
              if (pagination.pageIndex !== 0) {
                setPagination((prev: any) => ({ ...prev, pageIndex: 0 }));
                return;
              }
              await fetchDataWarehouse();
            }}
          >
            Tìm kiếm
          </Button>
        </Box>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        {isCheckViTri ? <Button
          leftSection={<IconTransactionEuro size={14} />}
          color="blue"
          variant="outline"
          onClick={() => {
            const ids = Object.keys(rowSelection);
            const idGroupp = idGroup || "";
            handleCreateLocation && handleCreateLocation(ids, idGroupp);
          }}
        >
          Phân quyền
        </Button> : (
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={<IconReload size={14} />}
              color="violet"
              variant="outline"
              onClick={async () => {
                loadingLocator();
              }}
            >
              Đồng bộ danh mục vị trí
            </Button>

            <Group justify="space-between" gap={0}>
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <Button
                    // size="xs"
                    rightSection={
                      <IconCaretDown
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Chức năng
                  </Button>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Label>Application</Menu.Label>
                  <Menu.Item
                    leftSection={
                      <IconFileExport
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                    onClick={() => exportDataExcel()}
                  >
                    Export Excel
                  </Menu.Item>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                    onClick={() => handleImportExcel()}
                  >
                    Import Excel
                  </Menu.Item>
                  <Menu.Item
                    leftSection={
                      <IconX style={{ width: rem(14), height: rem(14) }} />
                    }
                  >
                    Đóng
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Group>
          </Flex>
        )}
      </>
    ),

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id,
    // initialState: {
    //   showColumnFilters: false,
    //   columnPinning: {
    //     right: ["action"],
    //   },
    //   columnVisibility: { id: false },
    //   density: "xs",
    // },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableHeadCellProps: {
      style: {
        padding: "2px 15px",
        fontSize: "12.5px",
        fontWeight: 600,
      },
    },
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
      className: "compact-table-head",
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    if (!idsDepartment || data.length === 0) return;
    const ids = idsDepartment
      .toString()
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (ids.length === 0) return;
    const idSet = new Set(ids.map(String));
    const sel = data.reduce((acc: any, row: any) => {
      const rowId = String(row.id);
      if (idSet.has(rowId)) acc[rowId] = true;
      return acc;
    }, {} as MRT_RowSelectionState);
    setRowSelection(sel);
    table?.setRowSelection?.(sel);
  }, [idsDepartment, data, table]);

  useEffect(() => {
    const handleResize = () => {
      const rect = headerRef.current?.getBoundingClientRect();
      const top = rect?.top ?? 0;
      const toolbarHeight = rect?.height ?? 0;
      // 120 = thanh phân trang + thanh cuộn ngang + padding dưới
      setHeight(
        Math.max(window.innerHeight - top - toolbarHeight - 120, 220)
      );
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataInvCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );


  return (
    <>
      {isCheckViTri || hideBreadcrumb ? null :
        <div
          style={{
            border: "1px solid #dee2e6",
            padding: "0px 10px",
            overflowX: "hidden",
          }}
        >
          <BreadcrumbLayout1></BreadcrumbLayout1>
        </div>
      }
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default WarehouseLocationList;
